import styled from "styled-components";

const SectionWrapper = styled.div`
  padding: 50px 0;
  background: #ffffff;
  position: relative;
  z-index: 1;

  .ctaBox {
    max-width: 750px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding: 25px;
    border-radius: 14px;
    background: linear-gradient(135deg, #e08320 0%, #ca6e0f 100%);
    color: #ffffff;

    h3 {
      margin-bottom: 30px;
      font-weight: 500;
      color: #ffffff;
    }

    .btnWrap {
      display: flex;
      justify-content: center;
      gap: 25px;
      align-items: center;

      a.callbtn {
        color: #ffffff;
        font-size: 20px;
      }

      a.btn.btn-default.black {
        background: #000000;
        color: #ffffff;
        border: 1px solid #000000;
      }
    }
  }

  @media only screen and (max-width: 1440px) {
    padding: 40px 0;
  }
  @media only screen and (max-width: 767px) {
    padding: 42px 0;

    .btnWrap {
      flex-direction: column;
    }
  }
`;

export const Container = styled.div`
  max-width: 1627px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 1700px) {
    padding: 0 70px;
  }
  @media only screen and (max-width: 1360px) {
    padding: 0 30px;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ImageWrapper = styled.div`
  width: calc(100% - 507px);
  padding-right: 75px;
  position: relative;
  @media only screen and (max-width: 1200px) {
    width: 60%;
    padding-right: 50px;
  }
  @media only screen and (max-width: 991px) {
    padding-right: 0;
  }
  @media only screen and (max-width: 767px) {
    width: 100%;
    padding-right: 0;
    margin-bottom: 30px;
    transform: rotateY(-180deg);
  }
`;

export const TextWrapper = styled.div`
  width: 507px;
  @media only screen and (max-width: 991px) {
    padding-left: 50px;
  }
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    width: 100%;
  }

  h2 {
    @media only screen and (min-width: 1441px) {
      margin-bottom: 60px;
    }
    @media only screen and (min-width: 1440px) {
      margin-bottom: 40px;
    }
    @media only screen and (min-width: 767px) {
      margin-bottom: 30px;
    }
  }

  p {
    margin-bottom: 30px;
  }

  .learn__more-btn {
    margin-top: 20px;
  }
`;

export default SectionWrapper;
